import React from 'react';
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Submission from '../helpers/Submission';

let average = (array) => array.reduce((a, b) => a + b) / array.length;
//IN ASSESSMENT COMPONENT

class ArtifactScoreRow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            swapped: false
        };
    };

    getScore(artifact_id) {
        let scores = [];

        this.props.form.reviewers.map(function(reviewer) {
            let artifactObject = reviewer.artifactScores.filter(artifact => {
                return artifact.artifact_id === artifact_id;
            })
            let artifact = artifactObject[0];
            let reviewerScore = [];
            if(artifact){
                for (var score in artifact.rubricScores) {
                    reviewerScore.push(artifact.rubricScores[score]);
                }
                let reviewerNullFiltered = reviewerScore.filter(function (criteria_score) {
                    return criteria_score != null;
                });
                let reviewerNegativeFiltered = reviewerNullFiltered.filter(function(criteria_score){ return criteria_score > -1 });

                if(reviewerNegativeFiltered.length > 0) {
                    let s = reviewerNegativeFiltered.reduce((a, b) => a + b);
                    if(s >= 0) {
                        scores.push(s);
                    }
                }
            }
        })

        let nullFiltered = scores.filter(function (criteria_score) {
            return criteria_score != null;
        });

        if(nullFiltered.length == 0) {
            return 'Not Started';
        }

        let negativeFiltered = nullFiltered.filter(function(criteria_score){ return criteria_score > -1 });



        if(negativeFiltered.length == 0) {
            return 'Not Applicable';
        }

        return average(negativeFiltered).toFixed(2);

    }

    getMaxScore() {
        let maxScores = [];
        this.props.form.rubrics.map(function(criteria){
            maxScores.push(criteria.max_points);
        })
        return maxScores.reduce(function(a, b){return a+b;})
    }

    render() {
        return (
            <TableRow key={this.props.row.canvas_assignment_id + '-' + this.props.row.canvas_user_id}>
                <TableCell component="th" scope="row">
                    {this.props.row.course_code}
                </TableCell>
                <TableCell>{this.props.row.name}</TableCell>
                <TableCell>{this.props.row.canvas_assignment_name}</TableCell>
                <TableCell>{this.getScore(this.props.row.canvas_submission_id)}</TableCell>
                <TableCell>{this.getMaxScore()}</TableCell>
                <TableCell>{this.props.row.canvas_submission_id}</TableCell>
                <TableCell><Submission submission={this.props.row}/></TableCell>
            </TableRow>
        );
    }
}

function mapStateToProps(state) {
    return { form: state.newAssessmentForm, artifacts: state.artifacts };
}

export default connect(mapStateToProps, actions)(ArtifactScoreRow);